/**
 * Per-message body-format discriminator for chat.
 *
 * `forum_message.body` holds a mix: legacy rows are backend-escaped user text
 * or HTML the backend authored itself, while new rows are raw Markdown. The
 * API payload carries `flags` (a bitmask -- see `ForumMessage::FLAG_*`) plus a
 * derived `isMarkdown` boolean, mirroring how `WikiPageBasic` exposes `flags`
 * alongside `isPublic`. Either can be read; `isMarkdown` is the one to prefer,
 * so callers do not repeat the bit arithmetic.
 *
 */

/** Bit 1 of `flags`: the body is raw Markdown. Mirrors ForumMessage::FLAG_MARKDOWN. */
export const FLAG_MARKDOWN = 1;

/**
 * True when a message body is raw Markdown and must render through
 * `gf-markdown-viewer` (which sanitises), rather than the legacy trusted
 * `innerHTML | rawHtml` path.
 *
 * Anything not explicitly flagged -- a missing field, a legacy row, and
 * client-built messages such as macro responses -- is treated as legacy HTML.
 */
export function isMarkdownBody(msg: any): boolean {
    if (!msg) {
        return false;
    }

    // The derived boolean when the payload carries it, the bit otherwise --
    if (typeof msg.isMarkdown === 'boolean') {
        return msg.isMarkdown;
    }

    return ((msg.flags | 0) & FLAG_MARKDOWN) === FLAG_MARKDOWN;
}
